var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#1D1D1D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1201 10C16.1497 10 21.8272 10.0009 23.2461 10.3809C24.0325 10.5932 24.6514 11.2136 24.8604 11.999C25.2403 13.4247 25.2402 16.4004 25.2402 16.4004C25.2402 16.4393 25.238 19.3857 24.8604 20.8018C24.6485 21.59 24.0295 22.2095 23.2461 22.4189C21.8273 22.7989 16.1497 22.7998 16.1201 22.7998C16.1201 22.7998 10.4179 22.8 8.99316 22.4189C8.20701 22.2065 7.58884 21.587 7.37988 20.8018C7.00228 19.3857 7.00002 16.4393 7 16.4004C7 16.4004 6.9999 13.4247 7.37988 11.999C7.59169 11.2107 8.20981 10.5904 8.99316 10.3809C10.4179 9.99977 16.1201 10 16.1201 10ZM14.2979 19.1436L19.0361 16.4004L14.2979 13.6572V19.1436Z",
    fill: "#1D1D1D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.4e3fd7ac4b7a577ae78cd320a9159fd4.svg";
export { ForwardRef as ReactComponent };